import { countries } from "~/constants/countries"
import type { User } from "~/hooks/useSession";

export const formatCurrency = (amount: number, currency: string) => {
    return Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(amount);
};

export const getCurrency = (user: User | undefined) => {
    if (!user) return undefined;
    return countries.find((c) => c.value === user.country)?.currency;
};